import React from "react";
import "./popupModal.css";

const PopupModal = ({
  popupType,
  onClose,
  onCompletePayment,
  onDeleteAccount,
  onLogout,
  onSavePayments,
  onUpdateWeekly,
  paymentName,
  tempPaymentList,
}) => {
  let title, body, handleSubmit, hideProgressionButton, progressionButtonText;
  switch (popupType) {
    case "savePayments":
      const tempPaymentListLength = tempPaymentList.length;
      const maxListPayments = tempPaymentListLength === 3;
      const oneListPayment = tempPaymentListLength === 1;

      title = ` ${
        maxListPayments ? "Save" : "Only"
      } ${tempPaymentListLength} Payment${oneListPayment ? "" : "s"}?`;
      body = "payments are unchangeable for 7 days";
      handleSubmit = onSavePayments;
      hideProgressionButton = false;
      progressionButtonText = "Submit";
      break;
    case "completePayment":
      title = "Debt Paid?";
      body =
        "this cannot be manually undone but will auto reset after midnight MST";
      handleSubmit = onCompletePayment;
      hideProgressionButton = false;
      progressionButtonText = "Submit";
      break;
    case "updateWeekly":
      title = "Update Weekly?";
      body =
        "your current payments will be erased and you get to choose 3 new payments";
      handleSubmit = onUpdateWeekly;
      hideProgressionButton = false;
      progressionButtonText = "Continue";
      break;
    case "statBadgeTrophy":
      title = "Trophy Badge";
      body =
        "awarded by the DRAGON for maintaining your highest streak! if the streak breaks, the DRAGON will take it away";
      handleSubmit = onClose;
      hideProgressionButton = true;
      break;
    case "statBadgeFire":
      title = "Fire Badge";
      body =
        "awarded by the DRAGON for a 7-day streak! if the streak breaks, the DRAGON will take it away";
      handleSubmit = onClose;
      hideProgressionButton = true;
      break;
    case "statBadgeDragon":
      title = "Dragon Badge";
      body =
        "awarded by the DRAGON for a 30-day streak!iIf the streak breaks, the DRAGON will take it away";
      handleSubmit = onClose;
      hideProgressionButton = true;
      break;
    case "countdownInfo":
      title = "Debt Due?";
      body =
        " at midnight america/denver, the DRAGON will check your debt status, update your streak, and reset your payments";
      handleSubmit = onClose;
      hideProgressionButton = true;
      break;
    case "logout":
      title = "Logout?";
      body = "are you sure you want to logout and go back to the signin page?";
      handleSubmit = onLogout;
      hideProgressionButton = false;
      progressionButtonText = "Logout";
      break;
    case "deletAccount":
      title = "Delete Account?";
      body =
        "Deleting your account will remove you from any friends' list, and your informaton will be gone from our servers. THIS CANNOT BE UNDONE";
      handleSubmit = onDeleteAccount;
      hideProgressionButton = false;
      progressionButtonText = "DELETE ACCOUNT";
      break;
    default:
      title = "WATCHING YOU";
      body = "THE DRAGIN IS WATCHING";
      handleSubmit = onClose;
      hideProgressionButton = true;
  }

  const handleClick = () => {
    handleSubmit();
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popupOverlay" onClick={handleOverlayClick}>
      <div className="popupModal">
        <div className="popupModal-content">
          <h2>{title}</h2>
          <p>{paymentName !== "" ? paymentName : ""}</p>
          <p style={{ fontWeight: "normal", textTransform: "none" }}>{body}</p>
          <br />
          <button className="minButton" onClick={onClose}>
            {hideProgressionButton ? "Exit" : "Cancel"}
          </button>{" "}
          {!hideProgressionButton && (
            <button className="minButtonC2A" onClick={handleClick}>
              {progressionButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
